module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ack",
      "epub:type": "acknowledgments",
      "role": "doc-acknowledgments"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "FMH"
  }, [_c('span', {
    attrs: {
      "aria-label": "v",
      "id": "pg_v",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ack",
      "id": "ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("ACKNOWLEDGMENTS")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("I want to thank several busy people who took the time to answer my questions at length. Chambers’ prosecutor Linda Fairstein and his defense counsel Jack Litman were most generous. So were jurors Elizabeth Bauch, Eliot Kornhauser, Gerard Mosconi, Robert Nickey and Cole Wallace.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Colleagues and friends who provided welcome support and information were Sam Maull of the Associated Press, Irene Cornell of WCBS News Radio, Mike Pearl of "), _c('i', [_vm._v("The New York Post")]), _vm._v(" and Tim Clifford of "), _c('i', [_vm._v("New York Newsday,")]), _vm._v(" Larry Sutton and Pat Clark of the "), _c('i', [_vm._v("Daily News,")]), _vm._v(" Kirk Johnson of "), _c('i', [_vm._v("The New York Times,")]), _vm._v(" Danny Meenan Jr. and the staff of WMCA’s Barry Gray Show, Christine Cornell and Ellen Fleysher and Magee Hickey of WNBC-TV, Lou Young of WABC-TV, Jamie Zahn and Beverly Solochek of ABC-TV’s “Good Morning America,” Amy Rosenblum and Sue Wiggins of CBS “This Morning,” and Randy Doughit of “Larry King Live!”.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Important help came from Steve Marcus of the New "), _c('span', {
    attrs: {
      "aria-label": "vi",
      "id": "pg_vi",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("York Telephone Company, Sergeant Larry Engel and the Chambers trial court-officers crew, and Central Park tree coordinator Furman C. Horton 3d, who explained to me the difference between an American elm and a crabapple tree.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Special thanks to Bruno Butler for his constructive criticism and willingness to run errands—and to Ralph for everything.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2129ca1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 66
// module chunks = 0